/**
 *  데이터 타입
 *  ex) Any, String, Number, Integer, etc
 *  data_type 폴더 내 *.mode.ts 에서 *와 매핑된다.
 * @since 0.0.1
 * @author Heungsoo Ham
 * @enum
 */
export enum DataType {
    ANY = "Any",
    BOOLEAN = "Boolean",
    DATE = "Date",
    DATEARRAY = "[Date]",
    DATETIME = "Datetime",
    UTCDATE = "UTCDate",
    UTCDATEARRAY = "[UTCDate]",
    UTCDATETIME = "UTCDatetime",
    INTEGER = "Integer",
    INTEGERARRAY = "[Integer]",
    LOOKUP = "LookUp",
    LOOKUPARRAY = "[LookUp]",
    NUMBER = "Number",
    NUMBERARRAY = "[Number]",
    STRING = "String",
    STRINGARRAY = "[String]",
    TIME = "Time",
    UTCTIME = "UTCTime",
    TRISTATE = "Tristate",
    FILE = "File",
    SIGN = "Sign",
    USER = "User"
}
